import { useRef, useEffect } from 'react'
import { SwapContent } from '../../components/popover/content/SwapContent'
import { MainLayout } from '../../components/layout/MainLayout'

export function SwapPage() {
  const resetRef = useRef<(() => void) | null>(null)

  const handleSetReset = (resetFn: () => void) => {
    resetRef.current = resetFn
  }

  useEffect(() => {
    return () => {
      resetRef.current?.()
    }
  }, [])

  return (
    <MainLayout
      redirectOnSelect={false}
      hideBack={false}
      contentClassName="mt-0"
      className="h-screen min-h-auto mb-12"
      heightClassName="h-full"
    >
      <SwapContent className="p-0 pb-[64px]" onSetReset={handleSetReset} />
    </MainLayout>
  )
}
